
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { PrevisitChecklistComponent } from './previsit-checklist.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AlertModule } from '../alert/alert.module';
import { PipeModule } from 'shared/pipe/pipe.module';


@NgModule({
  imports: [
    NgbModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    AlertModule,
    PipeModule
  ],
  exports: [PrevisitChecklistComponent],
  declarations: [PrevisitChecklistComponent],
  providers: []
})
export class PrevisitChecklistModule { }
